import React, { Component } from 'react';
import Parse                from 'parse';
import AddCard              from './add-card';
import Utils                from '../../../Utils/Utility';
import Api                  from '../../../Utils/api';

export default class CardHolder  extends Component {

    constructor(props){
        super(props);

        this.state = {
            customerId          : '',
            paymentMethods      : [],
            initialMessage      : "Loading payment methods ...",
            error               : '',
            enableCardAddScreen : false,
            cardAddActionLabel  : 'Change',
            success             : false,
            updateCardDetail    : false,
            isCardAdded         : false
        }

        // this.changePaymentMethod     =    this.changePaymentMethod.bind(this);
        this.populatePaymentMethods     =    this.populatePaymentMethods.bind(this);
        this.renderPaymentMethods       =    this.renderPaymentMethods.bind(this);
        this.updatepaymentMethod        =    this.updatepaymentMethod.bind(this);
        this.renderDefaultSelectedCard  =    this.renderDefaultSelectedCard.bind(this);
        this.showSuccessAlert           =    this.showSuccessAlert.bind(this);
        this.handleAlert                =    this.handleAlert.bind(this);
    }

    componentWillMount() {
        if(this.props.activeLocation) {
            let cus_id = this.props.activeLocation["cus_id"];
            this.setState({ customerId : cus_id });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != null && nextProps.activeLocation) {
            this.setState({
                customerId : nextProps.activeLocation["cus_id"]
            },
            () => {
                this.populatePaymentMethods(null);
            });
        }
    }


    componentDidMount(){
        this.fetchLocationPaymentDetails();
    }


    showSuccessAlert(res){

        let self = this;

        this.setState({
            enableCardAddScreen: false,
            isCardAdded: true
        }, () => {
            self.fetchLocationPaymentDetails();
        });


    }

    handleAlert(){
        let self = this;

        this.setState({
            isCardAdded : false
        })
    }

    fetchLocationPaymentDetails = () => {
        let self = this;

        if (!this.props.activeLocation) {
            return;
        }

        const locId = this.props.activeLocation.objectId;
        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();

        if (Utils.isEmpty(this.state.customerId)) {

            Api.getLocationDetail(locId, userId, sessionToken)
                .then(
                    (result) => {
                        const locationDetail = result.data;
                        const customerId = locationDetail["cus_id"];
                        this.setState({
                                customerId          : customerId,
                                enableCardAddScreen : false
                            },
                            () => {
                                this.populatePaymentMethods(null, customerId);
                            });
                    },
                    (error) => {
                        console.log("Error occured while fetching latest user data!");
                    }
                );
        } else {
            this.populatePaymentMethods(null);
        }

    }

    populatePaymentMethods(paymentMethods, customerIdNew = null) {

        const self = this;
        if (Utils.isEmpty(this.state.customerId) && Utils.isEmpty(customerIdNew)){
            this.setState({
                initialMessage      : "Please add a credit card for billing.",
                paymentMethods      : [],
                enableCardAddScreen : true,
                updateCardDetail    : false
            });
            return;
        }


        let customerId = this.state.customerId ? this.state.customerId : customerIdNew;

        if (paymentMethods == null || paymentMethods.length == 0) {

            let userDetailPtrId = Parse.User.current().id;
            let sessionToken    = Parse.User.current().getSessionToken();

            Api.findCustomerData(userDetailPtrId, sessionToken, customerId, false)
                .then(
                    function(res) {
                        let initialMessage      = "";
                        let enableCardAddScreen = false;
                        let updateCardDetail    = true;
                        let results             = res.data;

                        if (results.length === 0) {
                            initialMessage      = "Please add a credit card for billing.";
                            enableCardAddScreen = true;
                            updateCardDetail    = false;
                        }

                        self.setState({
                            paymentMethods      : results,
                            initialMessage      : initialMessage,
                            enableCardAddScreen : enableCardAddScreen,
                            updateCardDetail    : updateCardDetail
                        });

                        // console.log("response:"+JSON.stringify(res));
                    },
                    function(error) {
                        console.log(error);
                        // self.setState({
                        //     initialMessage      : "Please add a credit card for billing.",
                        //     enableCardAddScreen : true
                        // });
                    }
                );

        } else {
            let initialMessage = "";
            if(paymentMethods.length === 0){
                initialMessage = "You have not saved any cards for transaction.";
            }

            self.setState({
                paymentMethods      : paymentMethods,
                initialMessage      : initialMessage,
                cardAddActionLabel  : 'Change',
                enableCardAddScreen : false,
                success             : true,
                updateCardDetail    : false
            });
        }
    }

    // changePaymentMethod(e){
    //
    //     e.preventDefault();
    //     if (this.state.cardAddActionLabel == 'Change') {
    //         this.setState({
    //             enableCardAddScreen : true,
    //             cardAddActionLabel  : 'Cancel',
    //             success             : false
    //         });
    //     } else if(this.state.cardAddActionLabel == 'Cancel') {
    //          this.setState({
    //              enableCardAddScreen : false,
    //              cardAddActionLabel  : 'Change',
    //              success             : false
    //         });
    //     }
    // }

    renderDefaultSelectedCard(savedCardsObj){
        let comp = null;
        let cardStatus = savedCardsObj.default;
        let paymentMethods = this.state.paymentMethods;

        //show default card when more than one saved cards is present
        if(cardStatus == true && paymentMethods.length > 1){
            comp = (
                <span className={"ml-10 defaultBtnContainer"} style={{verticalAlign:'super'}}>Default
                    <i className="fa fa-check" style={{marginLeft: "3px"}}></i>
                </span>
            );
        }

        return comp;

    }

    renderPaymentMethods(){

        let self           = this;
        let paymentMethods = this.state.paymentMethods;

        let component;
        if (paymentMethods.length === 0) {
            component = (
                <ul className="list-group">
                    <li className="list-group-item">
                        <b>{this.state.initialMessage}</b>
                    </li>
                </ul>
            );

        } else {
            component = (
                <div className={"col-sm-12 col-md-12 no-gutter"}>
                    <div className="panel panel-primary">
                        <ul className="list-group">
                            {
                                paymentMethods.map((paymentMethod, idx, array) => {
                                    return (
                                        <li className = "list-group-item" key = {'pm'+idx}>

                                            <i className="material-icons">account_balance_wallet</i> <span style={{verticalAlign:'super'}}>{paymentMethod.maskedNumber}</span>
                                            {
                                                this.renderDefaultSelectedCard(paymentMethod)
                                            }

                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>
                </div>
            );
        }
        return component;
    }

    getLocId = () => {
        let locId = "";

        if (this.props.activeLocation) {
            locId  = this.props.activeLocation.objectId;
        }

        return locId;
    }


    updatepaymentMethod = () => {
        this.setState(prevState => ({
            enableCardAddScreen : !prevState.enableCardAddScreen,
            isCardAdded         : false
        }));
    }

    render() {

        const locId = this.getLocId();

        return (
            <div className="row">
                {this.renderPaymentMethods()}

                {
                    this.state.isCardAdded ? (
                        <div className="alert alert-card-container alert-success alert-dismissible" role="alert">
                            <button type="button" className="close" onClick={this.handleAlert.bind(this)}><span aria-hidden="true">&times;</span>
                            </button>
                            <i className="fa fa-check-circle"></i>
                            <span className="ml-5">Card Added</span>
                            <strong> Successfully.</strong>
                        </div>
                    ) : null
                }

                { this.state.updateCardDetail && !this.state.enableCardAddScreen ? (
                    <div className="col-sm-12 col-md-12 no-gutter" >
                        <a href="javascript:void(0);" className="card-change-label"
                           onClick={this.updatepaymentMethod}><u> Change Card Detail</u></a>
                    </div>
                ) : null}


                {
                    this.state.enableCardAddScreen
                        ? <AddCard
                            locId = {locId}
                            callbackParent={this.showSuccessAlert}
                            updateCardDetail={this.state.updateCardDetail}
                            customerId = {this.state.customerId}
                            // callbackParent={this.fetchLocationPaymentDetails}
                        />
                        : null
                }

                {
                    this.state.success
                        ? (
                            <div className="alert alert-success" role="alert">
                                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                                <span className="sr-only">Success:</span>
                                Card added successfully.
                            </div>
                            )
                        : null
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/dashboard/billing/card-holder.js